import type { FieldErrors } from 'react-hook-form';
import { type LandingPageFormValues } from 'src/pages/Settings/memberships/components/landing-page-tab/types';
import { LandingPageTabValues } from 'src/pages/Settings/memberships/types';

export function getLandingPageErrorTab(
  errors: FieldErrors<LandingPageFormValues>,
): LandingPageTabValues | null {
  if (errors.name || errors.slug || errors.settings) {
    return LandingPageTabValues.Settings;
  }

  return errors.blocks ? LandingPageTabValues.Content : null;
}
